import { useEffect, useState } from 'react';
import imgFairLogo from '@/assets/img/fair-logo.svg';

export default function Header({
  feedbackButton = null,
  pathname = '',
}: {
  feedbackButton?: React.ReactNode;
  pathname?: string;
}) {
  const [progress, setProgress] = useState<number | null>(null);

  useEffect(() => {
    const handleProgress = (e: Event) => {
      const customEvent = e as CustomEvent<{ progress: number }>;
      setProgress(customEvent.detail.progress);
    };

    window.addEventListener('page-progress', handleProgress);
    return () => {
      window.removeEventListener('page-progress', handleProgress);
    };
  }, []);
  useEffect(() => {
    setProgress(null);
  }, [pathname]);
  // Determine copy based on pathname and progress
  let statusText = '';
  let isPending = false;
  if (pathname.includes('/checking-eligibility')) {
    statusText = progress === 100 ? 'Ready' : 'CHECKING YOUR AREA';
    isPending = progress !== 100;
  } else if (pathname.includes('/setting-up-case')) {
    statusText = progress === 100 ? 'Ready' : 'SETTING UP YOUR CASE';
    isPending = progress !== 100;
  }

  return (
    <div className="bg-primary-light pt-4 pb-0 w-full flex justify-center items-center">
      <div className="flex justify-between items-center w-full max-w-[800px] mx-auto px-[18px] lg:px-0">
        <div className="flex items-center gap-2.5">
          <img
            src={imgFairLogo}
            alt="logo"
            width={70}
            height={25}
            className="h-5 w-auto"
            style={{ aspectRatio: '70 / 25' }}
            fetchPriority="high"
          />
        </div>

        {statusText && (
          <div className="flex items-center gap-1.5 text-micro font-extrabold text-primary tracking-wider uppercase select-none">
            <span
              className={`w-1.5 h-1.5 rounded-full bg-primary ${isPending ? 'animate-pulse' : ''}`}
            />
            <span>{statusText}</span>
          </div>
        )}

        <div className="hidden">{feedbackButton}</div>
      </div>
    </div>
  );
}
